module.exports = "/365FarmNet/dist/fertilizerCore.7abe070c46516cab85b27ed3de2fc3da.html";